import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '../dialog/dialog.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { ToasterModule } from '../toaster/toaster.module';
import { ExportXeroActionComponent } from './components/export-xero-document-dropdown-item/export-xero-action.component';
import { XeroCurrencyComponent } from './components/xero-currency/xero-currency.component';
import { XeroExportSettingsComponent } from './components/xero-export-settings/xero-export-settings.component';
import { XeroIntegrationSetupComponent } from './components/xero-integration-setup/xero-integration-setup.component';
import { XeroIntegrationComponent } from './components/xero-integration/xero-integration.component';
import { XeroSettingsComponent } from './components/xero-settings/xero-settings.component';
import { XeroTaxesComponent } from './components/xero-taxes/xero-taxes.component';
import { I2gNgUiModule } from 'i2g-ng-ui';

const internalComponents = [
  XeroIntegrationComponent,
  XeroIntegrationSetupComponent,
  XeroSettingsComponent,
  XeroExportSettingsComponent,
  XeroTaxesComponent,
  XeroCurrencyComponent,
];

const externalComponents = [ExportXeroActionComponent];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormMasterModule,
    DialogModule,
    ToasterModule,
    I2gNgUiModule,
  ],
  declarations: [...internalComponents, ...externalComponents],
  exports: [...externalComponents],
})
export class XeroModule {}
